<template>
  <transition name="zm-alert-fade">
    <div
      class="zm-alert"
      :class="[typeClass, center ? 'is-center' : '']"
      v-show="visible"
      :role="role"
    >
      <i class="zm-alert__icon" aria-hidden :class="[ iconClass, isBigIcon ]" v-if="showIcon"></i>
      <div class="zm-alert__content">
        <div class="zm-alert__body">
          <span class="zm-alert__title" :class="[ isBoldTitle ]" v-if="title || $slots.title">
            <slot name="title">{{ title }}</slot>
          </span>
          <div class="zm-alert__description" v-if="$slots.default && !description">
            <slot></slot>
          </div>
          <p class="zm-alert__description" v-if="description && !$slots.default">
            {{ description }}
          </p>
        </div>
        <template v-if="closable">
          <zm-button
            v-if="closeText"
            class="zm-alert__closebtn is-customed"
            size="mini"
            ghost
            :aria-label="closeLabel || closeText || t('alert.close')"
            @click="close()"
          >
            {{closeText}}
          </zm-button>
          <zm-button
            v-else
            type="icon"
            class="zm-alert__closebtn"
            size="mini"
            ghost
            icon="zm-icon-close"
            :aria-label="closeLabel || t('alert.close')"
            @click="close()"
          />
        </template>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
  import '../../../i18n/alert';
  import Locale from '../../mixins/locale';
  import ZmButton from '../button';

  const TYPE_CLASSES_MAP = {
    'success': 'zm-icon-success',
    'warning': 'zm-icon-warning',
    'error': 'zm-icon-error'
  };
  export default {
    name: 'ZmAlert',
    mixins: [Locale],
    components: {
      ZmButton
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'info'
      },
      isStatic: Boolean,
      closable: {
        type: Boolean,
        default: true
      },
      closeText: {
        type: String,
        default: ''
      },
      closeLabel: {
        type: String,
        default: ''
      },
      showIcon: Boolean,
      center: Boolean
    },

    data() {
      return {
        visible: true
      };
    },

    methods: {
      close() {
        this.visible = false;
        this.$emit('close');
      }
    },

    computed: {
      typeClass() {
        return `zm-alert--${ this.type }`;
      },

      iconClass() {
        return TYPE_CLASSES_MAP[this.type] || 'zm-icon-Megaphone';
      },

      isBigIcon() {
        return this.description || this.$slots.default ? 'is-big' : '';
      },

      isBoldTitle() {
        return this.description || this.$slots.default ? 'is-bold' : '';
      },
      role() {
        if (this.isStatic) {
          return null;
        }
        return 'alert';
      }
    }
  };
</script>

<style lang="scss">
  @import "./style";
</style>
